import { statusBadgeClass, responseBadgeClass, surveyBadgeClass } from '../utils';

interface StatusBadgeProps {
  status: string | null | undefined;
  variant?: 'status' | 'response' | 'survey';
}

export default function StatusBadge({ status, variant = 'status' }: StatusBadgeProps) {
  if (!status) return <span className="badge badge--muted">—</span>;

  const cls =
    variant === 'response' ? responseBadgeClass(status) :
    variant === 'survey'   ? surveyBadgeClass(status)   :
    statusBadgeClass(status);

  return <span className={`badge ${cls}`}>{status}</span>;
}
